import producer from 'immer';
import { Reducer } from 'redux';
import { AuthTypes } from '~/store/ducks/auth/types';
import { UserState } from './types';

const INITIAL_STATE: UserState = {
  profile: null,
  infoHeader: null,
};

const reducer: Reducer<UserState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.PRE_SIGN_IN_SUCCESS:
      return producer(state, draft => {
        draft.profile = action.payload;
      });
    case AuthTypes.SIGNED_SUCCESS:
      return producer(state, draft => {
        draft.infoHeader = action.payload.data.infoHeader;
      });

    default:
      return state;
  }
};

export default reducer;
